var bindAjaxSpinner = function() {
  // change this to positives since
  $("form[data-remote]").not("#ebay-form").not("#amazon-form").not(".ebay-listing-form").bind('ajax:before', toggleSpinner);
  // need to do it this way because we delete forms during our ajax call
  $(document).ajaxStop(function(){
     $("#blocker").hide();
  });
}
window.bindAjaxSpinner = bindAjaxSpinner;
function toggleSpinner() {
  $("#blocker").toggle();
}
$(function(){
  bindAjaxSpinner();
});
